export const rteContentIsEmpty = (data: string): boolean => {
    if (data && data.length) {
        const dataWithoutMarkup = data.replace(/<(?:.|\n)*?>/gm, "");
        return !dataWithoutMarkup || !dataWithoutMarkup.length;
    } else {
        return true;
    }
};
